export const drawerWidth = 280;
export const drawerCloseWidth = 72;
